export default __webpack_public_path__ + "static/media/640_portfolio04-jp-web.7273d974.png";